import React, { useEffect, useRef, useState } from 'react';

import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, Modal, Tooltip, InputGroup, Form } from 'react-bootstrap';
import { EditionService } from '../../../services/EditionService';
import { UserService } from '../../../services/UserService';
import ErrorManager from "../../../components/error-manager/ErrorManager";

const RapportDialog = ({ show, setCloseModal }) => {

    const [showModal, setShowModal] = useState(false);
    const [globalError, setGlobalError] = useState();
    const [isSendLoading, setIsSendLoading] = useState(false);
    const [newRapport, setNewRapport] = useState();

    useEffect(() => {
        setShowModal(show)
        if (show) {
            resetValues()
        }
    }, [show]);

    function resetValues() {
        setGlobalError()
        setIsSendLoading(false)
        setNewRapport()
    }

    function handleClose(e) {
        setCloseModal()
    }

    function saveRapport() {
        setIsSendLoading(true)
        UserService.postRapport({ "rapport": newRapport, "url": window.location.href }).then(res => {
            setIsSendLoading(false)
            setCloseModal()
        }).catch(error => {
            setGlobalError(error)
            setIsSendLoading(false)
        });
    }

    return (
        <div id="RapportDialog">
            <Modal show={showModal} onHide={() => handleClose()} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Bugs & Suggestions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorManager error={globalError} />
                    <Form>
                        <Form.Group className="mb-2">
                            <Form.Control disabled={isSendLoading} onChange={e => setNewRapport(e.target.value)} as="textarea" placeholder="Décrivez un bug rencontré, faites nous part d'une suggestion..." rows={5} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={isSendLoading} variant="secondary" onClick={handleClose}>
                        Fermer
                    </Button>
                    <Button disabled={isSendLoading} className="ms-1" onClick={() => saveRapport()}>
                        Enregistrer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default RapportDialog;
